import React, { Component } from 'react';
import {
    Row,
    Col,
    Card,
    CardBody,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Badge,
    TabContent,
    ButtonDropdown,
    CustomInput,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    CardTitle,
} from 'reactstrap';
import axios from 'axios';
import { END_POINT, END_POINT_SOCKET } from '../../../constants/defaultValues';
import io from 'socket.io-client';
import {
    SetItemsSelected,
    NotificatioErrController,
    NotificatioSucController,
    AddCommaNumber,
} from '../../../helpers/Utils';
import {
    ListItemLeftForm,
    PageHeading,
    ComponentToPrintWrapper,
} from '../../../containers/pages/order';
import { Pagination } from '../../../containers/pages/general';
import { isD, isR } from '../../../helpers/Roles';
import LogsHelper from '../../../helpers/Logs';
import IntlMessages from '../../../helpers/IntlMessages';
import classNames from 'classnames';
import { Colxx, Separator } from '../../../components/common/CustomBootstrap';
import { connect } from 'react-redux';
import { clickOnMobileMenu, setContainerClassnames } from '../../../redux/actions';

const ROLE_ALIAS = 'order';

class ContentComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            page: {
                pageSizes: [8, 12, 24],
                selectedPageSize: 8,
                currentPage: 1,
                totalPage: 1,
                totalItem: 0,
                search: '',
            },
            selectedItems: [],
            selectedItemsDel: [],
            data: [],
            ordersDeleted: [],
            is_loading_data: true,
            show: {
                add: false,
                update: false,
                viewonly: true,
                print: false,
            },
            activeTab: '1',

            // password
            password: '',
            isOpenModalPassword: false,
            passwordFuncCallback: null,
            dropdownSplitOpen: false,
            dropdownOpenState: {},
        };
        this.socket = io(END_POINT_SOCKET);
    }

    componentDidMount() {
        this.dataListRender();
        this.getOrderDeleted();
    }

    onChangePage = (page) => {
        this.setState(
            (prev) => ({
                ...prev,
                page: {
                    ...prev.page,
                    currentPage: page,
                },
            }),
            () => this.dataListRender()
        );
    };

    onSearchKey = (e) => {
        if (!e) return false;

        if (e.target) {
            let {
                target: { value },
            } = e;
            let v = value;
            if (value === undefined) {
                v = e.target.firstElementChild.value; // parent to child

                value = v.toLowerCase();
                this.setState(
                    (prev) => ({
                        ...prev,
                        page: {
                            ...prev.page,
                            search: value,
                        },
                    }),
                    () => this.dataListRender()
                );
            } else {
                value = value.toLowerCase();
                this.setState(
                    (prev) => ({
                        ...prev,
                        page: {
                            ...prev.page,
                            search: value,
                        },
                    }),
                    () => this.dataListRender()
                );
            }
        }

        if (e.key === 'Enter') {
            let value = e.target.value.toLowerCase();
            this.setState(
                (prev) => ({
                    ...prev,
                    page: {
                        ...prev.page,
                        search: value,
                    },
                }),
                () => this.dataListRender()
            );
        }
    };

    onChangePageSize = (size) => {
        this.setState(
            (prev) => ({
                ...prev,
                page: {
                    ...prev.page,
                    selectedPageSize: size,
                    currentPage: 1,
                },
            }),
            () => this.dataListRender()
        );
    };

    /** Axios func helper */
    dataListRender = () => {
        const { selectedPageSize, currentPage, search } = this.state.page;

        let tokenStr = localStorage.getItem('access_token');
        axios
            .get(
                `${
                    END_POINT + '/bill/invoice'
                }?pageSize=${selectedPageSize}&currentPage=${currentPage}&search=${search}`,
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            )
            .then((res) => res.data)
            .then((data) => {
                this.setState((prev) => ({
                    ...prev,
                    items: data.data,
                    is_loading_data: false,
                    page: {
                        ...prev.page,
                        totalPage: data.totalPage,
                        totalItem: data.totalItem,
                    },
                }));
            })
            .catch((err) => {
                NotificatioErrController(err.response.data.responseText);
                return false;
            });
    };

    getOrderDeleted = () => {
        const { selectedPageSize, currentPage, search } = this.state.page;

        let tokenStr = localStorage.getItem('access_token');
        axios
            .get(
                `${
                    END_POINT + '/bill/invoiceDeleted'
                }?pageSize=${selectedPageSize}&currentPage=${currentPage}&search=${search}`,
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            )
            .then((res) => res.data)
            .then((data) => {
                this.setState((prev) => ({
                    ...prev,
                    ordersDeleted: data.data,
                    is_loading_data: false,
                    page: {
                        ...prev.page,
                        totalPage: data.totalPage,
                        totalItem: data.totalItem,
                    },
                }));
            })
            .catch((err) => {
                NotificatioErrController(err.response.data.responseText);
                return false;
            });
    };

    onContextMenu = (e, data) => {
        return true;
    };

    getOrdersIdFromSelected = (selected) => {
        let orders = [];
        for (let i = 0; i < selected.length; i++) {
            let bill = this.state.items.find(
                (_item) => _item.pin === selected[i]
            );

            if (bill) {
                let ids = bill.data.map((_order) => _order.id);
                orders = orders.concat(ids);
            }
        }
        return orders;
    };

    isMultiBill(items) {
        if (items.length < 2) {
            return false;
        }

        return true;
    }

    handleChangeSelectAll = (isToggle) => {
        if (this.state.selectedItems.length >= this.state.items.length) {
            if (isToggle) {
                this.setState({
                    selectedItems: [],
                });
            }
        } else {
            this.setState({
                selectedItems: this.state.items.map((x) => x.id),
            });
        }
        document.activeElement.blur();
        return false;
    };
    /** Axios func helper */

    /** State func helper */
    onChangePage = (page) => {
        this.setState(
            (prev) => ({
                ...prev,
                page: {
                    ...prev.page,
                    currentPage: page,
                },
            }),
            () => this.dataListRender()
        );
    };

    onChangePageDel = (page) => {
        this.setState(
            (prev) => ({
                ...prev,
                page: {
                    ...prev.page,
                    currentPage: page,
                },
            }),
            () => this.getOrderDeleted()
        );
    };

    onSearchKey = (e) => {
        if (!e) return false;

        if (e.target) {
            let {
                target: { value },
            } = e;
            let v = value;
            if (value === undefined) {
                v = e.target.firstElementChild.value; // parent to child

                // value = v.toLowerCase();
                // this.setState(
                //     (prev) => ({
                //         ...prev,
                //         page: {
                //             ...prev.page,
                //             search: value,
                //         },
                //     }),
                //     () => this.dataListRender()
                // );
            } 
            // else {
            //     value = value.toLowerCase();
            //     this.setState(
            //         (prev) => ({
            //             ...prev,
            //             page: {
            //                 ...prev.page,
            //                 search: value,
            //             },
            //         }),
            //         () => this.dataListRender()
            //     );
            // }
        }

        if (e.key === 'Enter') {
            let value = e.target.value.toLowerCase();
            this.setState(
                (prev) => ({
                    ...prev,
                    page: {
                        ...prev.page,
                        search: value,
                    },
                }),
                () => this.dataListRender()
            );
        }
    };

    onChangePageSize = (size) => {
        this.setState(
            (prev) => ({
                ...prev,
                page: {
                    ...prev.page,
                    selectedPageSize: size,
                    currentPage: 1,
                },
            }),
            () => this.dataListRender()
        );
    };

    onClickedItem = (item, callback, args) => {
        let selectedSet = SetItemsSelected(item.pin, this.state.selectedItems);

        this.setState(
            (prev) => ({
                ...prev,
                show: {
                    ...prev.show,
                    update: true,
                    viewonly: true,
                },
                selectedItems: selectedSet, //[item.id]
            }),
            () => {
                callback(args[0], args[1], args[2]);
            }
        );
    };

    onClickedItemDel = (item, callback, args) => {
        let selectedSet = SetItemsSelected(item.pin, this.state.selectedItemsDel);

        this.setState(
            (prev) => ({
                ...prev,
                // show: {
                //     ...prev.show,
                //     update: true,
                //     viewonly: true,
                // },
                selectedItemsDel: selectedSet, //[item.id]
            }),
            () => {
                callback(args[0], args[1], args[2]);
            }
        );
    };
    
    onClickedItemDelete = (item) => {
        // console.log('itemDel: ', item);
        this.onClickedItemDel(
            // callback
            item,
            this.menuButtonClick,
            [null, 1000, this.props.containerClassnames]
        );
    };

    menuButtonClick = (e, menuClickCount, containerClassnames) => {
        setTimeout(() => {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('resize', false, false);
            window.dispatchEvent(event);
        }, 350);
        this.props.setContainerClassnames(
            menuClickCount,
            containerClassnames,
            this.props.selectedMenuHasSubItems
        );
    };

    onClickedCheckbox = (id, callback) => {
        let selectedSet = SetItemsSelected(id, this.state.selectedItems);

        this.setState((prev) => ({
            ...prev,
            selectedItems: selectedSet,
        }));
    };

    onClickedCheckboxDel = (pin, callback) => {
        console.log('onClickedCheckboxDel: ', pin);
        // Tạo một bản sao của mảng state hiện tại để tránh thay đổi trực tiếp
        const { selectedItemsDel } = this.state;
        let newSelectedItems = [...selectedItemsDel];

        // Kiểm tra xem pin đã tồn tại trong mảng chưa
        const index = newSelectedItems.indexOf(pin);

        if (index > -1) {
            // Nếu đã tồn tại -> loại bỏ nó (bỏ tick)
            newSelectedItems.splice(index, 1);
        } else {
            // Nếu chưa tồn tại -> thêm nó vào (đánh tick)
            newSelectedItems.push(pin);
        }

        // Cập nhật lại state với mảng mới
        this.setState({
            selectedItemsDel: newSelectedItems
        });
    };
    /** State func helper */

    onDeleteBill = (pin) => {
        const arrayPin = [];
        arrayPin.push(pin);
        // console.log('arrayPin: ', arrayPin);

        // const { items } = this.state;
        // const newItems = items.filter((item) => item.pin !== pin);
        // this.setState((prevState) => ({
        //     ...prevState,
        //     items: newItems,
        // }));

        if (!isD(ROLE_ALIAS)) return false;

        let tokenStr = localStorage.getItem('access_token');
        axios
            .delete(`${END_POINT + '/order'}`, {
                data: {
                    arrayPin,
                },
                headers: { Authorization: `Bearer ${tokenStr}` },
            })
            .then((res) => res.data)
            .then((data) => {
                NotificatioSucController('Thành công');

                this.socket.emit('create logs', {
                    user_id: localStorage.getItem('user_id'),
                    message: LogsHelper['bill-delete'],
                });

                this.dataListRender();
            })
            .catch((err) => {
                NotificatioErrController(err.response.data.responseText);
                return false;
            });
    };

    onRestoreBill = (pin) => {
        const arrayPin = [pin]; // Viết gọn hơn

        if (!isD(ROLE_ALIAS)) return false;

        let tokenStr = localStorage.getItem('access_token');

        // Dữ liệu body của request
        const requestData = {
            arrayPin,
        };

        // Cấu hình chứa headers
        const requestConfig = {
            headers: { Authorization: `Bearer ${tokenStr}` },
        };

        axios
            .put(`${END_POINT}/order/restore-order`, requestData, requestConfig)
            .then((res) => {
                NotificatioSucController('Phục hồi hóa đơn thành công');

                this.socket.emit('create logs', {
                    user_id: localStorage.getItem('user_id'),
                    message: LogsHelper['bill-restore'],
                });

                this.getOrderDeleted();
            })
            .catch((err) => {
                // Nên kiểm tra err.response trước khi truy cập để tránh lỗi
                if (err.response && err.response.data && err.response.data.responseText) {
                    NotificatioErrController(err.response.data.responseText);
                } else {
                    NotificatioErrController('Có lỗi không xác định xảy ra.');
                }
                // Không cần 'return false' ở đây
            });
    };

    onDestroyBill = (pin) => {
        let text = "Bạn chắc chắn muốn xóa vĩnh viễn hóa đơn này?";
        if (window.confirm(text) === true) {        
            const arrayPin = [pin]; // Viết gọn hơn
            console.log('arrayPin: ', arrayPin);

            if (!isD(ROLE_ALIAS)) return false;

            let tokenStr = localStorage.getItem('access_token');

            axios
                .delete(`${END_POINT}/order/destroy-order`, {
                    // Đây là object 'config' duy nhất
                    headers: { 
                        Authorization: `Bearer ${tokenStr}` 
                    },
                    // Body của request DELETE được đặt trong thuộc tính 'data'
                    data: {
                        arrayPin,
                    }
                })
                .then((res) => {
                    NotificatioSucController(res.data.responseText);

                    this.socket.emit('create logs', {
                        user_id: localStorage.getItem('user_id'),
                        message: LogsHelper['bill-destroy'],
                    });

                    this.getOrderDeleted();
                })
                .catch((err) => {
                    // Nên kiểm tra err.response trước khi truy cập để tránh lỗi
                    if (err.response && err.response.data && err.response.data.responseText) {
                        NotificatioErrController(err.response.data.responseText);
                    } else {
                        NotificatioErrController('Có lỗi không xác định xảy ra.');
                    }
                    // Không cần 'return false' ở đây
                });
        }
    };

    toggleTab = (x) => {
        this.setState({
            activeTab: x,
        });
        if (x === '1') this.dataListRender();
        else if (x === '2'){
            this.getOrderDeleted();
        }
    };

    // toggleSplit = () => {
    //     this.setState((prevState) => ({
    //         dropdownSplitOpen: !prevState.dropdownSplitOpen,
    //     }));
    // };

    toggleSplitDel = (pin) => {
        // console.log('toggleSplitDel: ', a);
        // this.setState((prevState) => ({
        //     dropdownSplitOpenDel: !prevState.dropdownSplitOpenDel,
        // }));
        this.setState(prevState => ({
        dropdownOpenState: {
            ...prevState.dropdownOpenState,
            [pin]: !prevState.dropdownOpenState[pin]
        }
    }));
    };

    render() {
        const {
            items,
            ordersDeleted,
            selectedItems,
            selectedItemsDel,
            is_loading_data,
            show,
            page,
        } = this.state;
        // console.log('selectedItemsDel: ', selectedItemsDel);

        if (!isR(ROLE_ALIAS))
            return (
                <Card className='text-muted mh-40vh h-100'>
                    <CardBody className='d-flex justify-content-center align-items-center'>
                        Bạn không có quyền sử dụng tính năng này!
                    </CardBody>
                </Card>
            );

        const { match } = this.props;
        // const startIndex = (currentPage - 1) * selectedPageSize;
        // const endIndex = currentPage * selectedPageSize;

        // const is_multi_bill = this.isMultiBill(selectedItems);
        // console.log('ordersDeleted: ', ordersDeleted);

        return is_loading_data ? (
            <div className='loading' />
        ) : (
            <div className='disable-text-selection'>
                <PageHeading
                    heading='menu.invoice'
                    match={match}
                    setting={page}
                    orders_id={this.getOrdersIdFromSelected(selectedItems)}
                    itemsLength={items ? items.length : 0}
                    selectedItemsLength={
                        selectedItems ? selectedItems.length : 0
                    }
                    onSearchKeyFunc={this.onSearchKey}
                    changePageSizeFunc={this.onChangePageSize}
                    handleChangeSelectAllFunc={this.handleChangeSelectAll}
                />
                {items?.length === 0 ? (
                    <Card className='mt-4 mb-4 mh-53vh'>
                        <CardBody>Chưa có dữ liệu...</CardBody>
                    </Card>
                ) : (
                    <>
                        <Nav
                            tabs
                            className='d-flex separator-tabs ml-0 mb-5'
                        >
                            <NavItem>
                                <NavLink
                                    className={classNames({
                                        active: this.state.activeTab === '1',
                                        'nav-link': true,
                                    })}
                                    onClick={() => this.toggleTab('1')}
                                    location={{}}
                                    to='#'
                                >
                                    <IntlMessages id='general.info' />
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classNames({
                                        active: this.state.activeTab === '2',
                                        'nav-link': true,
                                    })}
                                    onClick={() => this.toggleTab('2')}
                                    location={{}}
                                    to='#'
                                >
                                    <span className='mr-2'>
                                        <i className='simple-icon-trash'></i>
                                    </span>
                                    HÓA ĐƠN ĐÃ HỦY
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent
                            activeTab={this.state.activeTab}
                            className='mh-53vh'
                        >
                            <TabPane tabId='1'>
                                <Row className='content-page__row'>
                                    <Col
                                        xs='12'
                                        sm='12'
                                        md='12'
                                        lg={selectedItems.length ? 7 : 12}
                                        xl={selectedItems.length ? 7 : 12}
                                    >
                                        {items?.length &&
                                            items?.map((bill, idx) => {
                                                return (
                                                    <ListItemLeftForm
                                                        onClickedItem={
                                                            this.onClickedItem
                                                        }
                                                        onChangeCheckbox={() => 
                                                            this.onClickedCheckbox()
                                                        }
                                                        selectedItems={
                                                            selectedItems
                                                        }
                                                        setting={show}
                                                        key={idx}
                                                        idx={idx}
                                                        item={bill}
                                                        isDisabledDelete={false}
                                                        onDeleteBill={
                                                            this.onDeleteBill
                                                        }
                                                    />
                                                );
                                            })}
                                        <Pagination
                                            currentPage={page.currentPage}
                                            totalPage={page.totalPage}
                                            onChangePage={(i) =>
                                                this.onChangePage(i)
                                            }
                                        />
                                    </Col>
                                    {selectedItems.length ? (
                                        <Col
                                            xs='12'
                                            sm='12'
                                            md='12'
                                            lg='5'
                                            xl='5'
                                        >
                                            <ComponentToPrintWrapper
                                                orders_id={this.getOrdersIdFromSelected(
                                                    selectedItems
                                                )}
                                            />
                                        </Col>
                                    ) : null}
                                </Row>
                            </TabPane>
                            <TabPane tabId='2'>
                                { ordersDeleted?.length ? ordersDeleted?.map((item, idx) => (
                                    <Card
                                        key={idx}
                                        className='mb-3 custom-shadow'
                                        onClick={() => {
                                            this.onClickedItemDelete(item);
                                        }}
                                    >
                                        <div className='position-absolute card-top-buttons custom-inline'>
                                            <div className='custom-control custom-checkbox pl-1 align-self-center pr-4'>
                                                <ButtonDropdown
                                                    isOpen={this.state.dropdownOpenState[item.pin] || false}
                                                    toggle={() => this.toggleSplitDel(item.pin)}
                                                    // onClick={() => this.onClickedItemDelete(item)}
                                                >
                                                    <div className='cursor-pointer btn btn-lg btn-primary pl-4 pr-0 check-button check-all'>
                                                        <CustomInput
                                                            className='custom-checkbox mb-0 d-inline-block'
                                                            type='checkbox'
                                                            id={idx}
                                                            checked={selectedItemsDel.includes(
                                                                item.pin
                                                            )}
                                                            onChange={(e) =>{
                                                                e.stopPropagation();
                                                                this.onClickedCheckboxDel(item.pin)}
                                                            }
                                                            label={
                                                                <span
                                                                    className={`custom-control-label`}
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                    <DropdownToggle
                                                        caret
                                                        color='primary'
                                                        className='dropdown-toggle-split'
                                                    />
                                                    <DropdownMenu right>
                                                        <DropdownItem
                                                            className={classNames('text-left')}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.onRestoreBill(item.pin)
                                                            }
                                                            }
                                                        >
                                                            Phục hồi hóa đơn
                                                        </DropdownItem>
                                                        <DropdownItem
                                                            className={classNames('text-left red')}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.onDestroyBill(item.pin)
                                                            }
                                                            }
                                                        >
                                                            Xóa vĩnh viễn
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </ButtonDropdown>
                                            </div>
                                        </div>
                                        <CardBody className='p-3'>
                                            <CardTitle className='mb-0'>
                                                {item.data[0].pin_print ? (
                                                    <Badge color='primary' pill>
                                                        Mã hoá đơn - #{item.data[0].pin_print}
                                                    </Badge>
                                                ) : (
                                                    <Badge color='secondary' pill>
                                                        Chưa in hoá đơn
                                                    </Badge>
                                                )}
                                            </CardTitle>
                    
                                            {item.data &&
                                                item.data.map((order, idx) => {
                                                    return (
                                                        <Colxx
                                                            xxs='12'
                                                            key={idx}
                                                            className='p-0 mt-3'
                                                        >
                                                            <span
                                                                className={classNames(
                                                                    'd-flex flex-row'
                                                                )}
                                                            >
                                                                <img
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src =
                                                                            'https://placehold.co/320x240';
                                                                    }}
                                                                    alt={order.name}
                                                                    src={
                                                                        order.product.image.indexOf(
                                                                            'http'
                                                                        ) >= 0
                                                                            ? order.product.image
                                                                            : END_POINT +
                                                                                '/public/' +
                                                                                order.product.image
                                                                    }
                                                                    className='list-thumbnail responsive border-0'
                                                                />
                                                                <div className='pl-2 d-flex flex-grow-1 min-width-zero'>
                                                                    <div
                                                                        className={classNames(
                                                                            'card-body p-2 align-items-center d-flex flex-ssm-column justify-content-between min-width-zero',
                                                                            {
                                                                                'flex-lg-row align-items-lg-center':
                                                                                    !show.update,
                                                                            }
                                                                        )}
                                                                    >
                                                                        <div className='w-75'>
                                                                            <p className='w-100 list-item-heading mb-1 truncate d-block'>
                                                                                {order.product.name}
                                                                            </p>
                                                                            <p className='mb-1 text-muted text-small w-100 w-sm-100'>
                                                                                {order.date +
                                                                                    ' - ' +
                                                                                    order.time}
                                                                            </p>
                                                                        </div>
                                                                        <div className='w-100 w-sm-100'>
                                                                            {order.discount ? (
                                                                                <Badge
                                                                                    className='mb-1 mr-1'
                                                                                    color='secondary'
                                                                                    pill
                                                                                >
                                                                                    {'Chiết khấu: ' +
                                                                                        DiscountRender(
                                                                                            order.discount
                                                                                        )}
                                                                                </Badge>
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                            {order.tax_fee ? (
                                                                                <Badge
                                                                                    className='mb-1 mr-1'
                                                                                    color='secondary'
                                                                                    pill
                                                                                >
                                                                                    {'Thuế: ' +
                                                                                        DiscountRender(
                                                                                            order.tax_fee
                                                                                        )}
                                                                                </Badge>
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                            {order.fee_other ? (
                                                                                <Badge
                                                                                    className='mb-1 mr-1'
                                                                                    color='secondary'
                                                                                    pill
                                                                                >
                                                                                    {'Phụ phí: ' +
                                                                                        DiscountRender(
                                                                                            order.fee_other
                                                                                        )}
                                                                                </Badge>
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                        </Colxx>
                                                    );
                                                })}
                                        </CardBody>
                                    </Card>
                                )) : 
                                    <Card className='mt-4 mb-4 mh-53vh'>
                                        <CardBody>Không có dữ liệu...</CardBody>
                                    </Card>
                                }
                                <Pagination
                                    currentPage={page.currentPage}
                                    totalPage={page.totalPage}
                                    onChangePage={(i) =>
                                        this.onChangePageDel(i)
                                    }
                                />
                            </TabPane>
                        </TabContent>
                    </>
                )}
            </div>
        );
    }
}

const DiscountRender = (discount) => {
    return discount?.type === 'price'
        ? AddCommaNumber(Math.round(discount?.value)) + ' đ'
        : discount?.value + ' %';
};

const mapStateToProps = ({ menu }) => {
    const { containerClassnames, menuClickCount, selectedMenuHasSubItems } =
        menu;
    return {
        containerClassnames,
        menuClickCount,
        selectedMenuHasSubItems,
    };
};

export default connect(mapStateToProps, {
    setContainerClassnames,
    clickOnMobileMenu,
})(ContentComponent);
